import { Card } from '@outdoorsyco/bonfire';
import cn from 'classnames';

import AspectRatio from '@/components/common/AspectRatio';
import { FavoriteButton } from '@/components/common/FavoriteButton';
import Link from '@/components/switchback/Link/Link';
import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';
import { WishlistModalWrapper } from '@/components/wishlists/WishlistModal';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { IWishlistingEventData } from '@/services/analytics/listings/types';
import { isProduction } from '@/utility/isSSR';
import { IBundleTile } from '@/utility/mapSearchResultToTile';

interface IEscapeTileCarouselProps {
  bundle: IBundleTile;
  wishlistingEventData?: IWishlistingEventData;
  isOutlined?: boolean;
  onClick?: () => void;
}

interface IEscapeTileCarouselItemProps {
  image: string;
}

const EscapeTileCarouselItem = ({ image }: IEscapeTileCarouselItemProps) => {
  return (
    <AspectRatio ratio="1.26:1" className="md:rounded-2xl">
      <ResponsiveImage src={image} className="rounded-2xl" enhanceImage />
    </AspectRatio>
  );
};

export const EscapeTileCarousel = ({
  bundle,
  wishlistingEventData,
  isOutlined,
  onClick,
}: IEscapeTileCarouselProps) => {
  const { isMobile } = useBreakpoint();
  const { isFavorite, imageUrls, slug } = bundle;

  return (
    <Link
      href={slug}
      legacy
      forceClientsideRouting
      target={!isMobile ? '_blank' : undefined}
      className="rounded-2xl"
      onClick={onClick}>
      <Card.Carousel
        className={cn('md:rounded-2xl h-1/2', {
          'outline outline-2 outline-offset-2 outline-green-500': isOutlined,
        })}
        fullRadius
        // Show a maximum of 7 images
        content={imageUrls.slice(0, 7).map((image, index) => (
          <EscapeTileCarouselItem
            key={`${!isProduction() ? index : 'image'}-${image}`}
            image={image}
          />
        ))}>
        <div className="absolute top-0 right-0 flex justify-end w-full p-2 gap-2">
          <WishlistModalWrapper
            isFavorite={isFavorite}
            item={bundle}
            itemType="escape"
            wishlistingEventData={wishlistingEventData}
            TriggerComponent={({ isFavorite: isWishlisted, toggleFavorite }) => (
              <FavoriteButton
                isFavorite={isWishlisted}
                onClick={toggleFavorite}
                hideFavoriteCount={true}
              />
            )}
          />
        </div>
      </Card.Carousel>
    </Link>
  );
};
